(ns dashboard.views.analysis.analysis-bank.subs
  (:require [re-frame.core :as rf]
            [dashboard.views.analysis.analysis-bank.config :as config]))

(rf/reg-sub
  ::include-initialized-analyses
  (fn [db _]
    (get-in db [config/view-id :include-initialized-analyses] true)))
